.hostSelect{
    height: 46px;
    display: flex;
    justify-content: center;
    gap: 32px;
}

.hostOption{
    flex-shrink: 2;
    display: flex;
    align-items: center;
    gap: 8px;
}

.hostOption label{
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    margin: 0;
}

.hostOption label h6{
    margin: 0;
    line-height: 24px;
    white-space: pre-line;
}

.hostIconSet{
    display:flex;
    position: relative;
    height: 46px;
}

.hostIcon{
    height:46px;
    width:46px;
    border-radius: 100%;
}

.hostIconRest{
    position: relative;
    left: -10px;
}

.hostIconFirst{
    position:absolute;
}

.hostLabelContainer{
    max-width: 170px;
}

@media (max-width: 992px){
    .hostOption label h6{
        font-size: 16px!important;
    }
}

@media (max-width: 825px){
    .hostSelect{
        flex-direction: column;
        height: unset;
    }

    .hostOption label h6{
        white-space: unset;
    }
}